export const handleWindowReload = (): void => {
  window.location.reload()
}